import { useState } from "react";
import ParamAutocomplete from "../../components/ParamAutocomplete/ParamAutocomplete";
import { Button } from "@mui/material";

export default function FiltersBar({ onSearch, trens = [] }) {

  const [filters, setFilters] = useState({
    TremId: "",
    Carro: "",
    ParameterId: "",
    StartDate: "",
    EndDate: "",
    Limit: 100
  });

  const tremSelecionado = trens.find(
    (t) => String(t.identificadorTrem) === String(filters.TremId)
  );

  const opcoesCarro = Array.from(
    { length: tremSelecionado?.quantidadeCarros || 0 },
    (_, i) => i + 1
  );

  const handleNumberChange = (field, value, min = 0, max = null) => {

    if (value === "") {
      setFilters(prev => ({ ...prev, [field]: "" }));
      return;
    }

    const num = Number(value);

    if (Number.isNaN(num)) return;

    if (num < min) return;

    if (max !== null && num > max) return;

    setFilters(prev => ({ ...prev, [field]: num }));
  };

  const blockInvalidKeys = (e) => {
    if (["-", "+", "e", "E", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="filters-card">

      <div className="filters-grid">

        <label className="filter-field">
          <span>Trem</span>
          <select
            value={filters.TremId}
            onChange={e => {
              const novoTremId = e.target.value;
              const tremInfo = trens.find(
                (t) => String(t.identificadorTrem) === String(novoTremId)
              );
              const carroValido =
                filters.Carro &&
                tremInfo &&
                Number(filters.Carro) <= tremInfo.quantidadeCarros;

              setFilters(prev => ({
                ...prev,
                TremId: novoTremId === "" ? "" : Number(novoTremId),
                Carro: carroValido ? prev.Carro : ""
              }));
            }}
          >
            <option value="">Todos</option>
            {trens.map((t) => (
              <option key={t.id} value={t.identificadorTrem}>
                {t.nomeCodigo}
              </option>
            ))}
          </select>
        </label>

        <label className="filter-field">
          <span>Carro</span>
          <select
            value={filters.Carro}
            disabled={!tremSelecionado}
            onChange={e => {
              const novoCarro = e.target.value;
              setFilters(prev => ({
                ...prev,
                Carro: novoCarro === "" ? "" : Number(novoCarro)
              }));
            }}
          >
            <option value="">
              {tremSelecionado ? "Todos" : "Selecione um trem"}
            </option>
            {opcoesCarro.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>

        <label className="filter-field">
          <span>Qtd. resultados</span>
          <input
            type="number"
            min={1}
            max={5000}
            value={filters.Limit}
            onChange={e => handleNumberChange("Limit", e.target.value, 1, 5000)}
            onKeyDown={blockInvalidKeys}
            placeholder="Ex: 100"
          />
        </label>

        <label className="filter-field">
          <span>Parâmetro</span>
          <ParamAutocomplete
            selectedParam={filters.ParameterId}
            onSelect={(id) =>
              setFilters({ ...filters, ParameterId: id })
            }
          />
        </label>

        <label className="filter-field">
          <span>Data inicial</span>
          <input
            type="datetime-local"
            value={filters.StartDate}
            onChange={e =>
              setFilters({ ...filters, StartDate: e.target.value })
            }
          />
        </label>

        {/* Data final */}
        <label className="filter-field">
          <span>Data final</span>
          <input
            type="datetime-local"
            value={filters.EndDate}
            onChange={e =>
              setFilters({ ...filters, EndDate: e.target.value })
            }
          />
        </label>

      </div>

      <div className="filters-actions">
        <Button
          variant="contained"
          onClick={() => {

            const adjustedFilters = {
              ...filters,

              Limit: Math.min(Number(filters.Limit) || 100, 5000),

              StartDate: filters.StartDate
                ? new Date(filters.StartDate).toISOString()
                : "",

              EndDate: filters.EndDate
                ? new Date(filters.EndDate).toISOString()
                : "",
            };

            onSearch(adjustedFilters);
          }}
        >
          Buscar
        </Button>
      </div>

    </div>
  );
}